import { FC } from 'react';
import { zodResolver } from '@hookform/resolvers/zod';
import { z } from 'zod';
import { FormProvider, useForm } from 'react-hook-form';

import { CriteriaCreateFormFields, CriteriaCreateFormState } from '../types';
import { getCriteriaDefaultValues } from '../utils';

export const CriteriaCreateFormSchema = z.object({
  [CriteriaCreateFormFields.NAME]: z.string().min(1, 'Name is required'),
  [CriteriaCreateFormFields.DESCRIPTION]: z.string().optional(),
  [CriteriaCreateFormFields.IS_LIVE]: z.preprocess((value) => value === 'true', z.boolean()),
  [CriteriaCreateFormFields.SEARCH_QUERY]: z.any(),
});

export const CriteriaCreateFormProvider: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const defaultValues = getCriteriaDefaultValues();
  const methods = useForm<CriteriaCreateFormState>({
    defaultValues,
    mode: 'onSubmit',
    shouldUnregister: true,
    resolver: zodResolver(CriteriaCreateFormSchema),
  });

  return <FormProvider {...methods}>{children}</FormProvider>;
};
